<template>
  <section class="section">
    <div class="container">
      <h1 class="title">Page Not Found</h1>
      <p>
        We can&rsquo;t seem to find the page you&rsquo;re looking for&hellip;
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PageNotFound'
};
</script>
